import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fce14f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row status"
}
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "qr-frame" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ご利用可能ポイント", -1))
const _hoisted_6 = {
  key: 1,
  class: "row expire"
}
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = {
  key: 0,
  class: "col-12"
}
const _hoisted_9 = { class: "row justify-content-center smart-lock" }
const _hoisted_10 = {
  key: 2,
  class: "menu row"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ポイント実績", -1))
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ご利用履歴", -1))
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "マイページ", -1))
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "お支払い", -1))

import {ref, reactive, inject, onMounted, toRefs, watch, getCurrentInstance, onUnmounted} from 'vue'
import Qrcode from '@/components/Qrcode.vue';
import { Member, SmartLock } from '@/models';
import { useRoute, useRouter } from 'vue-router';
import { Auth, DataStore, Hub, Predicates, SortDirection } from 'aws-amplify';
import SmartLockEl from '@/components/SmartLock.vue';

import dayjs from 'dayjs';
import 'dayjs/locale/ja';

interface Props {
  member: Member;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    member: null
  },
  emits: ['stopLoading'],
  setup(__props: any, { emit }) {

const props = __props as {
  member: Member;
}



const { member } = toRefs(props);

const api: any = inject('api');



const router = useRouter();
const route = useRoute();

const smartLockList = ref<SmartLock[]>([]);

const memberTypeName = ref<string | null | undefined>('');
const expired = ref(false);

const memberPoint = ref(0);

const init = async() => {
  try {
    const authSession = await Auth.currentSession();
    const token = authSession.getAccessToken().getJwtToken();
    api.setCognitoToken(token);

    memberPoint.value = member.value.point || 0;

    await pollingMemberPoint();

    if (!member.value.memberType) {
      emit('stopLoading');
      return;
    }

    const memberTypeId = member.value.memberType?.id;
    memberTypeName.value = member.value.memberType?.name;

    expired.value = member.value.memberExpire == null || dayjs().isAfter(dayjs(member.value.memberExpire));
    
    smartLockList.value = await DataStore.query(SmartLock, (sl) => sl.shopID('eq', member.value.shopID!),{
        sort: s => s.displayOrder(SortDirection.ASCENDING)
      });
    smartLockList.value = smartLockList.value.sort((a, b) => b.displayOrder == null ? -1 : 0);

    if (!isStaff()) {
      smartLockList.value = smartLockList.value.filter((sl) => sl.memberTypeIds?.includes(memberTypeId!));
      smartLockList.value = smartLockList.value.filter((sl) => member.value.gender == 1 || (member.value.gender == 0 && !sl.isFemale));
    }
  }
  catch(e) {
    console.log(e);
  }
  emit('stopLoading');
}
init();

watch(member, async() => {
  init();
})

const pollingMemberPoint = async() => {
  try {
    if (route.name != 'home') {
      return;
    }
    const m = await DataStore.query(Member, member.value.id);
    memberPoint.value = m?.point || 0;
    console.log('updated member point');
    setTimeout(pollingMemberPoint, 5000);
  }
  catch(e) {
    console.log(e);
  }
}

const getCode = () => {
  return ('000000' + member.value.codeNum).slice(-6);
}

const isStaff = () => {
  return member.value.memberType?.monthlyPrice == 0;
}

const isNoType = () => {
  return member.value.memberType == null;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(member))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_unref(member))
                ? (_openBlock(), _createBlock(Qrcode, {
                    key: 0,
                    text: _unref(member).id,
                    size: 120
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, _toDisplayString(getCode()), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(member).name) + "様", 1),
            _hoisted_5,
            _createElementVNode("div", null, _toDisplayString(memberPoint.value?.toLocaleString()) + "pt", 1),
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('buy')))
            }, "ポイント購入")
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(member) && memberTypeName.value && !isNoType())
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(memberTypeName.value), 1),
          (_unref(member).memberExpire)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 有効期限 " + _toDisplayString(_unref(dayjs)(_unref(member).memberExpire).format('YYYY年MM月DD日')), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(smartLockList.value, (smartLock) => {
        return (_openBlock(), _createBlock(SmartLockEl, {
          smartLock: smartLock,
          expired: expired.value,
          key: smartLock.id
        }, null, 8, ["smartLock", "expired"]))
      }), 128))
    ]),
    (_unref(member))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "col-6",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('point')))
          }, [
            _createElementVNode("img", {
              src: require('@/assets/img/icon-mypage-1.png')
            }, null, 8, _hoisted_11),
            _hoisted_12
          ]),
          _createElementVNode("div", {
            class: "col-6",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('work')))
          }, [
            _createElementVNode("img", {
              src: require('@/assets/img/icon-mypage-2.png')
            }, null, 8, _hoisted_13),
            _hoisted_14
          ]),
          _createElementVNode("div", {
            class: "col-6",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('mypage')))
          }, [
            _createElementVNode("img", {
              src: require('@/assets/img/icon-mypage-3.png')
            }, null, 8, _hoisted_15),
            _hoisted_16
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["col-6", {'disabled' : isStaff() || isNoType() }]),
            onClick: _cache[4] || (_cache[4] = () => { 
    if(!isStaff() && !isNoType()) {
      _unref(router).push('extention')
    } 
  } )
          }, [
            _createElementVNode("img", {
              src: require('@/assets/img/icon-mypage-4.png')
            }, null, 8, _hoisted_17),
            _hoisted_18
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})